import { styled } from '@mui/material/styles';

export const StyledItemWrapper = styled('div')({
  display: 'flex',
});

export const StyledIconWrapper = styled('div')({
  marginRight: '12px',
});

export const StyledDescription = styled('div')({
  marginTop: '4px',
});

export const StyledItemContent = styled('div')({
  marginTop: '20px',
});

export const StyledTextContentWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flex: '1 1 auto',
});
